<template>
  <div class="media-container">
    <b-container fluid v-if="loaded">
      <b-row class="image-row">
        <b-col v-for="(image, idx) in imageList" :key="`image-${idx}`" class="text-center p-0 m-1">
          <b-img
           v-bind="mainProps"
           :src="image.thumbnail ? image.thumbnail : image.url"
           :alt="image.title"
           v-b-popover.hover.bottom="image.excerpt ? image.excerpt : 'No description.'"
           @click="setSelected(idx)"
           v-b-modal.images-modal
           style="cursor: pointer; object-fit: cover;">
           </b-img>
        </b-col>
      </b-row>
      <!-- Lightbox modal -->
      <media-modal :selectedImage="selectedImage" :imageList="imageList"></media-modal>
    </b-container>
  </div>
</template>

<script>
/**
 * Area media component.
 *
 * This component contains all the interactions
 * for media gallery on map detail gallery tab.
 */
import axios from 'axios';
import {
  APIBASEURL,
} from '@/utils/constants';
import AreaMediaModalVue from './AreaMediaModal';

export default {
  props: ['site'],
  data() {
    return {
      imageList: [],
      loaded: false,
      mainProps: { width: 150, height: 150 },
      selectedImage: null,
    };
  },
  components: {
    'media-modal': AreaMediaModalVue,
  },
  mounted() {
    const params = {
      tag: this.site.properties.area_rd,
      geoReferenced: false,
      type: 'image',
    };
    axios
      .get(`${APIBASEURL}/media/`, { params })
      .then((resp) => {
        this.loaded = true;
        this.imageList = resp.data;
      });
  },
  methods: {
    /**
     * Set selected image to be set on lightbox
     * @param {image} idx - value of image
     */
    setSelected(idx) {
      this.selectedImage = idx;
    },
  },
};
</script>

<style>
.image-row {
  padding: 1rem 0;
}

.media-container {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
</style>
